import React from 'react';
import Theme from '../Theme';

/**
 * wrap component in NetX theme
 * @example
	const ThemedComponenet = withTheme(Componenet);
 */
export const withTheme = function <C extends React.ElementType>(Component: C) {
	return (
		props: JSX.IntrinsicAttributes &
			JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>,
	) => {
		return (
			<Theme>
				<Component {...props} />
			</Theme>
		);
	};
};
